class Slider {
  constructor($el) {
    this.$el = $el;
    this.$slider = $el.find('[data-slider="slider"]');
    this.$pages = $el.find('[data-slider="pages"]');
    this.$index = $el.find('[data-slider="index"]');
    this.$total = $el.find('[data-slider="total"]');
    this.$prev = $el.find('[data-slider="prev"]');
    this.$next = $el.find('[data-slider="next"]');
    this.slick = null;
    this.init();
  }

  init = () => {
    import("slick-carousel").then(() => {
      this.slick = this.$slider.slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        speed: 1000,
        dots: false,
        arrows: true,

        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });

      this.$slider.on("afterChange", this.sliderAfterChangeHandler);

      this.$prev.on("click", () => {
        this.$slider.slick("slickPrev");
      });
      this.$next.on("click", () => {
        this.$slider.slick("slickNext");
      });

      this.setResponsiveIndex();
    });
  };

  setResponsiveIndex = () => {
    let { slick } = this.slick[0];
    let slidedsToShow = slick.activeBreakpoint
      ? slick.breakpointSettings[slick.activeBreakpoint].slidesToShow
      : 3;
    let index = Math.round(slick.currentSlide / slidedsToShow) + 1;
    let total = Math.ceil(slick.slideCount / slidedsToShow);

    if (total <= 1) {
      this.$pages.addClass("d-none");
    } else {
      this.$pages.removeClass("d-none");
    }

    this.$index.text(index);
    this.$total.text(total);
  };

  sliderAfterChangeHandler = (e, slick, currentSlide) => {
    this.setResponsiveIndex();
  };
}

export default Slider;
